import React from "react";

function isCabinetNode(node) {
  const category = String(
    node?.category || node?.definition?.category || ""
  ).toLowerCase();

  return category.includes("cabinet.box") || category.includes("cabinet");
}

function parseNumber(value) {
  if (value === "") return "";
  const n = Number(value);
  return Number.isFinite(n) ? n : value;
}

export default function ShelvesSimplePanel({
  selectedNode,
  resolvedNode,
  onChangeNode,
}) {
  const node = selectedNode || resolvedNode;

  if (!node || !isCabinetNode(resolvedNode || node)) {
    return null;
  }

  const overrides = node.parameterOverrides || {};
  const effective = resolvedNode?.effectiveParameters || {};

  function updateParam(key, value) {
    onChangeNode?.({
      id: node.id,
      parameterOverrides: {
        ...(node.parameterOverrides || {}),
        [key]: parseNumber(value),
      },
    });
  }

  return (
    <div className="border rounded p-3 bg-white space-y-3">
      <div>
        <div className="font-semibold text-sm">Shelves</div>
        <div className="text-xs text-slate-500">
          Brzo podešavanje unutrašnjih polica.
        </div>
      </div>

      <div>
        <label className="text-xs text-slate-500">Shelf count</label>
        <input
          type="number"
          value={overrides.shelfCount ?? ""}
          placeholder={String(effective.shelfCount ?? 0)}
          onChange={(e) => updateParam("shelfCount", e.target.value)}
          className="w-full px-2 py-1 border rounded text-sm"
        />
      </div>

      <div className="grid grid-cols-4 gap-2">
        {[0, 1, 2, 3].map((count) => (
          <button
            key={count}
            type="button"
            onClick={() => updateParam("shelfCount", count)}
            className="px-2 py-2 border rounded bg-slate-50 text-sm"
          >
            {count}
          </button>
        ))}
      </div>
    </div>
  );
}